import index from "./forgot.vue";
export default index;
